import {
  ADD_NEW_FOLDER_FROM_MOVE_MODAL,
  CLEAR_CHECKED_ITEMS,
  CLOSE_DASHBOARD_CARD_DROPDOWNS,
  CREATE_NEW_FOLDER_FAILED,
  CREATE_NEW_FOLDER_HIDE,
  CREATE_NEW_FOLDER_LOAD,
  CREATE_NEW_FOLDER_SHOW,
  CREATE_NEW_FOLDER_SUCCESS,
  CREATE_NEW_FOLDER_UPDATE_NAME,
  DASHBOARD_INIT,
  DISCARD_RENAME_CARD,
  FETCH_FAVORITES,
  FETCH_FOLDERS,
  FETCH_HIERARCHY,
  FETCH_TOP_LEVEL_FOLDERS,
  FETCH_VIDEOS,
  FOLDER_DESCRIPTION_CHANGED,
  FOLDER_DESCRIPTION_EDITED,
  FOLDER_DESCRIPTION_EDITING,
  REMOVE_FOLDERS,
  REMOVE_VIDEOS,
  RENAME_CARD,
  RESET_VIDEOS,
  RESTORE_FROM_PAST,
  SHARE_FOLDER_FAILED,
  SHARE_FOLDER_HIDE_MODAL,
  SHARE_FOLDER_LOADING,
  SHARE_FOLDER_SUCCESS,
  SHOW_DASHBOARD_CARD_DROPDOWN,
  TOGGLE_DASHBOARD_UPGRADE_MODAL,
  TOGGLE_LOOM_DOWNLOAD_MODAL,
  TOGGLE_RECORD_TO_NON_DEFAULT_WORKSPACE_MODAL,
  TOGGLE_SIDEBAR_COLLAPSED,
  UNSHARE_FOLDER_LOADING,
  UNSHARE_FOLDER_SUCCESS,
  UPDATE_ALL_RECENT_VIDEOS_FETCHED,
  UPDATE_ALL_VIDEOS_FETCHED,
  UPDATE_BREADCRUMBS,
  UPDATE_CHECKED_ITEMS,
  UPDATE_CURRENT_FOLDER_INFO,
  UPDATE_DRAGGING_ITEMS,
  UPDATE_DRAGGING_MULTIPLE,
  UPDATE_FAVORITES,
  UPDATE_FOLDERS,
  UPDATE_FOLDERS_ERROR,
  UPDATE_FOLDERS_HIERARCHY,
  UPDATE_FOLDER_CHANGES_PENDING,
  UPDATE_FOLDER_NAME,
  UPDATE_FOLDER_TO_MOVE_TO,
  UPDATE_HAS_FETCHED_RECENT_TEAM_VIDEOS,
  UPDATE_IS_ARCHIVED,
  UPDATE_IS_FAVORITE,
  UPDATE_IS_FAVORITES_PAGE,
  UPDATE_IS_JTBD,
  UPDATE_IS_SHARED_WITH_ME_PAGE,
  UPDATE_PAGE_TYPE,
  UPDATE_PAST,
  UPDATE_PAST_FOLDER_NAME,
  UPDATE_RECENT_TEAM_VIDEOS,
  UPDATE_SELECTED_SUB_HEADER,
  UPDATE_SELECTED_WORKSPACE,
  UPDATE_SHOW_MOVE_MODAL,
  UPDATE_TOP_LEVEL_FOLDERS,
  UPDATE_TOTAL_VIDEO_COUNT,
  UPDATE_USER_FAVORITE_FOLDER,
  UPDATE_USER_FAVORITE_VIDEO,
  UPDATE_VIDEOS,
  UPDATE_VIDEOS_ERROR,
  UPDATE_VIDEOS_GRID,
  UPDATE_VIDEO_NAME,
  UPDATE_WELCOME_LOOMS,
  UPDATE_WELCOME_LOOMS_FETCHED,
  UPDATE_WELCOME_PERSONA_TEXT,
  UPDATE_WORKSPACE_LIBRARY_VIDEO_COUNTS,
} from 'constants/actions';
import {
  DEFAULT_FOLDER_NAME,
  FOLDER_NAME_HOW_TO_USE_LOOM,
  FOLDER_NAME_JTBD,
  MY_VIDEOS_FOLDER_NAME,
  SPECIAL_FOLDER_ID_MY_VIDEOS,
} from 'constants/folders';
import { MY_ARCHIVE_FILTER } from 'constants/videosDashboard';
import { prioritizeSignedThumbnails } from 'utilities/video';

import { PRIVATE_WORKSPACE } from '../../../shared/constants/workspaces';

const DEFAULT_VIDEOS_DASHBOARD_STATE = {
  all_videos_fetched: false,
  allRecentVideosFetched: false,
  breadcrumbs: [],
  card_dropdown_id: '',
  checked_items: [],
  dragging_multiple: false,
  dragging_items: false,
  error: null,
  is_favorite: false,
  favorites: [],
  folders: [],
  folders_hierarchy: [],
  folder_collaborators: [],
  folder_id: null,
  folder_special_id: SPECIAL_FOLDER_ID_MY_VIDEOS,
  folder_name: MY_VIDEOS_FOLDER_NAME,
  folder_description: '',
  folder_description_editing: false,
  folder_owner_id: null,
  folder_owner: {},
  folder_shared: false,
  folder_changes_pending: false,
  folder_to_move_to: {},
  root_folder_id: SPECIAL_FOLDER_ID_MY_VIDEOS,
  root_is_public: false,
  has_fetched_favorites: false,
  has_fetched_folders: false,
  has_fetched_top_level_folders: false,
  hasFetchedRecentTeamVideos: true,
  has_fetched_videos: false,
  is_archived: false,
  is_favorites_page: false,
  is_shared_with_me_page: false,
  is_fetching_favorites: false,
  is_fetching_folders: false,
  is_fetching_hierarchy: false,
  is_fetching_top_level_folders: false,
  is_fetching_videos: false,
  is_jtbd: false,
  parent_folder_id: '',
  past: [],
  read_only: false,
  recentTeamVideos: [],
  rename_id: '',
  selectedSubHeader: MY_ARCHIVE_FILTER,
  show_move_modal: false,
  top_level_folders: [],
  videos: [],
  new_folder_name: DEFAULT_FOLDER_NAME,
  show_new_folder_input: false,
  total_video_count: null,

  show_share_folder_modal: false,
  share_folder_loading: false,
  share_folder_error: null,
  share_folder_id: '',
  share_folder_name: '',
  unshare_folder_loading: false,

  show_upgrade_modal: false,

  show_collaborate_modal: false,
  collaborate_entity_id: null,
  collaborate_entity_name: '',
  collaborate_entity_type: null,
  collaborate_entity_is_shared: false,
  collaborate_entity_owner_id: null,
  collaborate_entity_owner_email: null,

  show_recorder_download_modal: false,
  show_record_to_non_default_workspace_modal: false,

  workspace: PRIVATE_WORKSPACE,

  sidebar_is_collapsed: false,

  pageType: '',
  isRoot: false,
  welcome_looms: null,
  welcome_persona_text: '',

  library_video_counts: {},
};

const videosDashboardReducer = (
  state = DEFAULT_VIDEOS_DASHBOARD_STATE,
  action
) => {
  switch (action.type) {
    case DASHBOARD_INIT:
      return {
        ...state,
        root_folder_id: action.rootFolderId,
        root_is_public: Boolean(action.rootIsPublic),
        read_only: Boolean(action.rootIsPublic),
      };
    case CLOSE_DASHBOARD_CARD_DROPDOWNS:
      return {
        ...state,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
      };
    case DISCARD_RENAME_CARD:
      return {
        ...state,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
      };
    case SHOW_DASHBOARD_CARD_DROPDOWN:
      return {
        ...state,
        card_dropdown_id: action.id,
      };
    case FETCH_FAVORITES:
      return {
        ...state,
        has_fetched_favorites: false,
        is_fetching_favorites: true,
      };
    case FETCH_FOLDERS:
      return {
        ...state,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
        error: null,
        is_fetching_folders: true,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
      };
    case FETCH_HIERARCHY:
      return {
        ...state,
        is_fetching_hierarchy: true,
        folders_hierarchy: DEFAULT_VIDEOS_DASHBOARD_STATE.folders_hierarchy,
      };
    case FETCH_TOP_LEVEL_FOLDERS:
      return {
        ...state,
        has_fetched_top_level_folders:
          DEFAULT_VIDEOS_DASHBOARD_STATE.has_fetched_top_level_folders,
        is_fetching_top_level_folders: true,
      };
    case FETCH_VIDEOS:
      return {
        ...state,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
        error: null,
        is_fetching_videos: true,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
      };
    case RENAME_CARD:
      return {
        ...state,
        rename_id: action.id,
      };
    case RESET_VIDEOS:
      return {
        ...state,
        all_videos_fetched: DEFAULT_VIDEOS_DASHBOARD_STATE.all_videos_fetched,
        error: DEFAULT_VIDEOS_DASHBOARD_STATE.error,
        has_fetched_videos: DEFAULT_VIDEOS_DASHBOARD_STATE.has_fetched_videos,
        is_fetching_videos: DEFAULT_VIDEOS_DASHBOARD_STATE.is_fetching_videos,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
        videos: DEFAULT_VIDEOS_DASHBOARD_STATE.videos,
      };
    case RESTORE_FROM_PAST:
      return Object.assign({}, state, state.past.slice(-1).pop(), {
        error: DEFAULT_VIDEOS_DASHBOARD_STATE.error,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
        is_fetching_folders: DEFAULT_VIDEOS_DASHBOARD_STATE.is_fetching_folders,
        is_fetching_videos: DEFAULT_VIDEOS_DASHBOARD_STATE.is_fetching_videos,
        past: state.past.slice(0, -1),
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
        recentTeamVideos: state.recentTeamVideos,
      });
    case UPDATE_ALL_RECENT_VIDEOS_FETCHED:
      return {
        ...state,
        allRecentVideosFetched: action.allRecentVideosFetched,
        has_fetched_videos: true,
        is_fetching_videos: false,
      };
    case UPDATE_ALL_VIDEOS_FETCHED:
      return {
        ...state,
        all_videos_fetched: action.allVideosFetched,
        has_fetched_videos: true,
        is_fetching_videos: false,
      };
    case UPDATE_WELCOME_LOOMS_FETCHED:
      return {
        ...state,
        welcome_looms_fetched: action.welcomeLoomsFetched,
      };
    case UPDATE_BREADCRUMBS:
      return {
        ...state,
        breadcrumbs: action.breadcrumbs,
      };
    case UPDATE_CHECKED_ITEMS:
      return {
        ...state,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
        checked_items: action.checkedItems,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
      };
    case UPDATE_CURRENT_FOLDER_INFO:
      return {
        ...state,
        folder_collaborators: [...action.collaborators],
        folder_id: action.id,
        folder_special_id: action.specialId,
        folder_name: action.name,
        folder_description: action.description,
        folder_shared: action.shared,
        is_favorite: action.favorite,
        parent_folder_id: action.parentId,
        folder_owner_id: action.ownerId,
        folder_owner: action.owner,
      };
    case UPDATE_DRAGGING_MULTIPLE:
      return {
        ...state,
        dragging_multiple: action.draggingMultiple,
      };
    case UPDATE_DRAGGING_ITEMS:
      return {
        ...state,
        dragging_items: action.dragging,
      };
    case UPDATE_FAVORITES:
      return {
        ...state,
        favorites: action.favorites,
        has_fetched_favorites: true,
        is_fetching_favorites:
          DEFAULT_VIDEOS_DASHBOARD_STATE.is_fetching_favorites,
      };
    case UPDATE_FOLDER_CHANGES_PENDING:
      return {
        ...state,
        folder_changes_pending: action.pending,
      };
    case UPDATE_FOLDER_NAME:
      return {
        ...state,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
        folders: state.folders.map(folder => {
          return folder.id === action.id
            ? { ...folder, name: action.newName }
            : folder;
        }),
      };
    case UPDATE_FOLDERS:
      return {
        ...state,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
        checked_items: DEFAULT_VIDEOS_DASHBOARD_STATE.checked_items,
        folders_hierarchy: DEFAULT_VIDEOS_DASHBOARD_STATE.folders_hierarchy,
        folder_to_move_to: DEFAULT_VIDEOS_DASHBOARD_STATE.folder_to_move_to,
        has_fetched_folders: true,
        is_fetching_folders: false,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
        folders: action.folders,
      };
    case UPDATE_FOLDERS_ERROR:
      return {
        ...state,
        error: action.err,
        has_fetched_folders: true,
        is_fetching_folders: false,
      };
    case UPDATE_FOLDERS_HIERARCHY:
      return {
        ...state,
        folder_to_move_to: DEFAULT_VIDEOS_DASHBOARD_STATE.folder_to_move_to,
        folders_hierarchy: action.hierarchy,
        is_fetching_hierarchy: false,
      };
    case UPDATE_IS_ARCHIVED:
      return {
        ...state,
        is_archived: action.archived,
      };
    case UPDATE_IS_FAVORITE:
      return {
        ...state,
        is_favorite: action.favorite,
      };
    case UPDATE_IS_JTBD:
      return {
        ...state,
        all_videos_fetched: true,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
        checked_items: DEFAULT_VIDEOS_DASHBOARD_STATE.checked_items,
        folder_id: FOLDER_NAME_JTBD,
        folder_special_id: FOLDER_NAME_JTBD,
        folder_shared: false,
        folder_name: FOLDER_NAME_HOW_TO_USE_LOOM,
        folder_description:
          'Learn how to unlock the value of quick videos and become an even better communicator with these custom videos we recorded just for you',
        has_fetched_folders: true,
        has_fetched_videos: true,
        is_jtbd: action.isJTBD,
        read_only: true,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
      };
    case UPDATE_FOLDER_TO_MOVE_TO:
      return {
        ...state,
        folder_to_move_to:
          action.folder || DEFAULT_VIDEOS_DASHBOARD_STATE.folder_to_move_to,
      };
    case UPDATE_HAS_FETCHED_RECENT_TEAM_VIDEOS:
      return {
        ...state,
        hasFetchedRecentTeamVideos: action.hasFetchedRecentTeamVideos,
      };
    case UPDATE_PAST:
      return {
        ...state,
        past: action.past,
      };
    case UPDATE_RECENT_TEAM_VIDEOS:
      return {
        ...state,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
        error: null,
        hasFetchedRecentTeamVideos: true,
        is_fetching_videos: false,
        recentTeamVideos:
          action.videos || DEFAULT_VIDEOS_DASHBOARD_STATE.recentTeamVideos,
      };
    case UPDATE_SHOW_MOVE_MODAL:
      return {
        ...state,
        folder_to_move_to: DEFAULT_VIDEOS_DASHBOARD_STATE.folder_to_move_to,
        show_move_modal: action.show,
        show_new_folder_input: false,
      };
    case UPDATE_TOP_LEVEL_FOLDERS:
      return {
        ...state,
        has_fetched_top_level_folders: true,
        is_fetching_top_level_folders:
          DEFAULT_VIDEOS_DASHBOARD_STATE.is_fetching_top_level_folders,
        past: state.past.map(pastItem => {
          pastItem.top_level_folders = action.folders;

          return pastItem;
        }),
        top_level_folders: action.folders,
      };
    case UPDATE_USER_FAVORITE_FOLDER:
      return {
        ...state,
        folders: state.folders.map(folder => {
          if (folder.id !== action.folderId) {
            return folder;
          }

          return {
            ...folder,
            isUserFavorite: action.isFavorite,
          };
        }),
      };
    case UPDATE_USER_FAVORITE_VIDEO:
      return {
        ...state,
        videos: state.videos.map(video => {
          if (video.id !== action.videoId) {
            return video;
          }

          return {
            ...video,
            isUserFavorite: action.isFavorite,
          };
        }),
      };
    case UPDATE_VIDEO_NAME:
      return {
        ...state,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
        videos: state.videos.map(video => {
          if (video.id !== action.id) {
            return video;
          }

          return {
            ...video,
            name: action.newName,
          };
        }),
        recentTeamVideos: state.recentTeamVideos.map(video => {
          if (video.id !== action.id) {
            return video;
          }

          return {
            ...video,
            name: action.newName,
          };
        }),
      };
    case UPDATE_VIDEOS:
      return {
        ...state,
        card_dropdown_id: DEFAULT_VIDEOS_DASHBOARD_STATE.card_dropdown_id,
        error: null,
        has_fetched_videos: true,
        is_fetching_videos: false,
        videos: (action.videos || DEFAULT_VIDEOS_DASHBOARD_STATE.videos).map(
          prioritizeSignedThumbnails
        ),
      };
    case UPDATE_VIDEOS_ERROR:
      return {
        ...state,
        error: action.err,
        has_fetched_videos: true,
        is_fetching_videos: false,
      };
    case UPDATE_VIDEOS_GRID:
      return {
        ...state,
        rename_id: DEFAULT_VIDEOS_DASHBOARD_STATE.rename_id,
        videos: (action.videos || DEFAULT_VIDEOS_DASHBOARD_STATE.videos).map(
          prioritizeSignedThumbnails
        ),
      };
    case CREATE_NEW_FOLDER_UPDATE_NAME:
      return { ...state, new_folder_name: action.name };
    case CREATE_NEW_FOLDER_LOAD: {
      const myVideos = state.folders_hierarchy[0];
      const newFolder = {
        folder: {
          id: null,
          local_id: action.local_id,
          parent_folder_id: action.parent_folder_id,
          name: action.folder_name,
        },
        children: [],
      };

      return {
        ...state,
        show_new_folder_input: false,
        folder_to_move_to: newFolder.folder,
        folders_hierarchy: [
          {
            folder: myVideos.folder,
            children: [newFolder, ...myVideos.children],
          },
        ],
      };
    }
    case CREATE_NEW_FOLDER_SUCCESS: {
      const myVideos = state.folders_hierarchy[0];
      const folderFromAction = { folder: action.folder, children: [] };

      const children = myVideos.children.map(orgFolder =>
        orgFolder.folder.local_id == action.folder.local_id
          ? folderFromAction
          : orgFolder
      );

      return {
        ...state,
        new_folder_name: DEFAULT_VIDEOS_DASHBOARD_STATE.new_folder_name,
        folder_to_move_to: state.show_new_folder_input
          ? state.folder_to_move_to
          : action.folder,
        folders: [action.folder, ...state.folders],
        folders_hierarchy: [
          {
            folder: myVideos.folder,
            children,
          },
        ],
      };
    }
    case CREATE_NEW_FOLDER_FAILED:
      return { ...state };
    case CREATE_NEW_FOLDER_SHOW:
      return { ...state, show_new_folder_input: true };
    case CREATE_NEW_FOLDER_HIDE:
      return { ...state, show_new_folder_input: false };
    case SHARE_FOLDER_LOADING:
      return {
        ...state,
        share_folder_loading: true,
        show_share_folder_modal: true,
        share_folder_id: action.id,
        share_folder_name: action.name,
      };
    case SHARE_FOLDER_SUCCESS:
      return {
        ...state,
        share_folder_loading: false,
        folder_shared:
          state.folder_id == action.folderId ? true : state.folder_shared,
        folders: state.folders.map(folder =>
          folder.id == action.folderId ? { ...folder, shared: true } : folder
        ),
        top_level_folders: state.top_level_folders.map(folder =>
          folder.id == action.folderId ? { ...folder, shared: true } : folder
        ),
        favorites: state.favorites.map(folder =>
          folder.id == action.folderId ? { ...folder, shared: true } : folder
        ),
      };
    case SHARE_FOLDER_FAILED:
      return { ...state, share_folder_error: action.error };
    case SHARE_FOLDER_HIDE_MODAL:
      return {
        ...state,
        share_folder_loading: false,
        show_share_folder_modal: false,
      };
    case UNSHARE_FOLDER_LOADING:
      return { ...state, unshare_folder_loading: true };
    case UNSHARE_FOLDER_SUCCESS:
      return {
        ...state,
        unshare_folder_loading: false,
        show_share_folder_modal: false,
        folder_shared:
          state.folder_id == action.folderId ? false : state.folder_shared,
        folders: state.folders.map(folder =>
          folder.id == action.folderId ? { ...folder, shared: false } : folder
        ),
        top_level_folders: state.top_level_folders.map(folder =>
          folder.id == action.folderId ? { ...folder, shared: false } : folder
        ),
        favorites: state.favorites.map(folder =>
          folder.id == action.folderId ? { ...folder, shared: false } : folder
        ),
      };
    case FOLDER_DESCRIPTION_EDITING:
      return { ...state, folder_description_editing: true };
    case FOLDER_DESCRIPTION_CHANGED:
      return { ...state, folder_description: action.description };
    case FOLDER_DESCRIPTION_EDITED:
      return { ...state, folder_description_editing: false };
    case UPDATE_TOTAL_VIDEO_COUNT:
      return { ...state, total_video_count: action.count };
    case TOGGLE_DASHBOARD_UPGRADE_MODAL:
      return {
        ...state,
        show_upgrade_modal:
          action.showModal === null
            ? !state.show_upgrade_modal
            : action.showModal,
      };
    case UPDATE_SELECTED_WORKSPACE:
      return {
        ...state,
        workspace: action.workspace,
      };
    case TOGGLE_SIDEBAR_COLLAPSED:
      return {
        ...state,
        sidebar_is_collapsed: action.isCollapsed,
      };
    case UPDATE_IS_FAVORITES_PAGE:
      return {
        ...state,
        is_favorites_page: action.isFavorites,
      };
    case UPDATE_IS_SHARED_WITH_ME_PAGE:
      return {
        ...state,
        is_shared_with_me_page: action.isSharedWithMePage,
      };
    case REMOVE_FOLDERS:
      return {
        ...state,
        folders: state.folders.filter(
          folder => !action.folderIds.includes(folder.id)
        ),
      };
    case REMOVE_VIDEOS:
      return {
        ...state,
        videos: state.videos.filter(
          video => !action.videoIds.includes(video.id)
        ),
      };
    case CLEAR_CHECKED_ITEMS:
      return {
        ...state,
        checked_items: DEFAULT_VIDEOS_DASHBOARD_STATE.checked_items,
      };
    case TOGGLE_LOOM_DOWNLOAD_MODAL:
      return {
        ...state,
        show_recorder_download_modal: action.payload.show,
      };
    case TOGGLE_RECORD_TO_NON_DEFAULT_WORKSPACE_MODAL:
      return {
        ...state,
        show_record_to_non_default_workspace_modal: action.payload.show,
      };
    case UPDATE_PAST_FOLDER_NAME:
      return {
        ...state,
        past: state.past.map(p => {
          p.folders.map(folder => {
            if (folder.id !== action.id) {
              return folder;
            }

            return {
              ...folder,
              name: action.name,
            };
          });

          return p;
        }),
      };

    case UPDATE_SELECTED_SUB_HEADER:
      return {
        ...state,
        selectedSubHeader: action.subHeader,
      };

    case ADD_NEW_FOLDER_FROM_MOVE_MODAL:
      return {
        ...state,
        folders: [{ ...action.folder }, ...state.folders],
      };

    case UPDATE_PAGE_TYPE: {
      const { pageType, isRoot } = action;

      return {
        ...state,
        pageType,
        isRoot,
      };
    }
    case UPDATE_WORKSPACE_LIBRARY_VIDEO_COUNTS:
      return {
        ...state,
        library_video_counts: {
          ...state.library_video_counts,
          ...action.counts,
        },
      };
    case UPDATE_WELCOME_LOOMS:
      return {
        ...state,
        welcome_looms: action.welcomeLooms,
      };
    case UPDATE_WELCOME_PERSONA_TEXT:
      return {
        ...state,
        welcome_persona_text: action.welcomePersonaText,
      };
    default:
      return state;
  }
};

export default videosDashboardReducer;
